exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title-secondary-bold{font-size:14px;font-size:.875rem;font-weight:700;margin-top:1.5rem}@media (min-width:576px){.title-secondary-bold{margin-top:3.8125rem}}", ""]);

